export enum HousingType {
  NoHousing = 'No Housing',
}
export enum IconType {
  Tax = 'Tax',
  NonTax = 'NonTax',
  Receipt = 'Receipt',
}
export enum InsuranceStatus {
  Accepted = 'Accepted',
  Declined = 'Declined',
  WaitingPeriodBenefit = 'WaitingPeriodBenefit',
}
export enum PreviewContainerFieldNames {
  arrivingTravel = 'assignment.travel.arrivingTravel',
  endingTravel = 'assignment.travel.endingTravel',
  interimTravel = 'assignment.travel.interimTravel',
  amnFlight = 'assignment.travel.amnFlight',
  amnRentalCar = 'assignment.travel.amnRentalCar',
  payRate = 'payRate',
  payCallBackFactor = 'payCallBackFactor',
  payAmountPerMile = 'payAmountPerMile',
  overTimeRate = 'overTimeRate',
  premiumPayRate = 'premiumPayRate',
  doubletimeRate = 'doubletimeRate',
  onCallRate = 'payOnCallRate',
  lodgingPerDiem = 'lodgingPerDiem',
  mealPerDiem = 'mealPerDiem',
  cellPhoneStipend = 'cellPhoneStipend',
  tlaCarAllowance = 'tlaCarAllowance',
  tlaMealAllowance = 'tlaMealAllowance',
  tlaShiftCompletionBonus = 'tlaShiftCompletionBonus',
  tlaCellPhoneStipend = 'tlaCellPhoneStipend',
  housingType = 'housingType',
  additionalFurniture = 'additionalFurniture',
  housingCoPay = 'housingCoPay',
  furnitureCoPay = 'furnitureCoPay',
  earlyMoveInDate = 'earlyMoveInDate',
  lateMoveOutDate = 'lateMoveOutDate',
}
export enum DurationType {
  hr = 'hr',
  day = 'day',
  shift = 'shift',
}

export enum FieldType {
  string = 'string',
  number = 'number',
  date = 'date',
}

export enum BonusFields {
  facilitySignOn = 'Facility Sign On',
  facilityCompletion = 'Facility Completion',
}
